'use client'

import React from 'react'
import LanguageSwitcher from '../LanguageSwitcher'

interface HeaderActionsProps {
  isI18n: boolean
  t: (key: string) => string
  Link: React.ComponentType<{
    href: string
    className: string
    prefetch: boolean
    children: React.ReactNode
  }>
}

/**
 * Header Actions Component
 * Language switcher and CTA buttons (Contact Us, Book Now)
 */
export function HeaderActions({ isI18n, t, Link }: HeaderActionsProps) {
  return (
    <div className="nav-buttons">
      {isI18n && <LanguageSwitcher variant="dropdown" />}
      <Link href="/contact" className="contact-us-btn" prefetch={false}>
        {t('contactUs')}
      </Link>
      <a href="/booking" className="book-now-btn">
        {t('bookNow')}
      </a>
    </div>
  )
}
